// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__28On5","loaderOuter":"PageOverlayLoader_loaderOuter__SL7xe"};